import { render, staticRenderFns } from "./SessionParticipantHorse.vue?vue&type=template&id=24ad350d"
import script from "./SessionParticipantHorse.vue?vue&type=script&lang=js"
export * from "./SessionParticipantHorse.vue?vue&type=script&lang=js"
import style0 from "./SessionParticipantHorse.vue?vue&type=style&index=0&id=24ad350d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDivider,VRow})
